export default {
  fonts: {
    body: "Kumbh Sans, sans-serif",
    heading: "Kumbh Sans, serif",
  },
  fontSizes: [
    14, // 0
    16, // 1
    18, // 2
    20, // 3
    24, // 4
    36, // 5
    48, // 6
    56, // 7
    90, // 8
  ],
  fontWeights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
}
